import React, { useState, useEffect } from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { getDateFormat } from "@utils/datePickerUtils";
import { Tooltip } from "react-tooltip";
import { Image } from "hesus-ui-kit";
import commentIcon from "@icons/ic-comment.svg";
import { DivBackgroundOpacity, DivToolTip } from "@utils/extra-style";
import { renderPriceWithCurrencyWithoutUnit } from "@utils/utils";
import { DueDateSpan } from "../../QuoteList.styled";
import "../../QuoteList.scss";

const QuoteGeneralInfo = (props) => {
  const { t, data, column } = props;
  const [colorClass, setColorClass] = useState("#474747");

  const tooltipId = `quote-tooltip-${data.id}`;
  const tooltipAnchor = `#quote-tooltip-${data.id}`;

  useEffect(() => {
    if (column === "dunningInfoData") {
      const currentDate = new Date();
      const dueDateTIme = new Date(data.dunningDate).getTime();
      if (dueDateTIme < currentDate) {
        setColorClass("#E83F1E");
      }
    }
  }, [column]);

  return (
    <>
      <DivBackgroundOpacity opacity={data.isActive !== 5 ? 1 : "0.2"}>
        {column === "quoteTotal" &&
          (data.totalExcludingTax ? (
            <DueDateSpan color="#474747" fontStyle="normal" fontWeight="700">
              {data.currency?.symbol
                ? renderPriceWithCurrencyWithoutUnit(
                    data.totalExcludingTax,
                    data.currency.symbol,
                    data.currency.position
                  )
                : data.totalExcludingTax}
            </DueDateSpan>
          ) : (
            "-"
          ))}

        {column === "validationDate" &&
          (data.status === 1 || data.status === 2) && (
            <DueDateSpan color="#474747" fontStyle="italic">
              {data.estimatedValidationDate
                ? getDateFormat(data.estimatedValidationDate, "YYYY-MM-DD")
                : "-"}
            </DueDateSpan>
          )}
        {column === "validationDate" && data.status === 3 && (
          <DueDateSpan color="#008395" fontStyle="normal" fontWeight="700">
            {data.wonDate ? getDateFormat(data.wonDate, "YYYY-MM-DD") : "-"}
          </DueDateSpan>
        )}
        {column === "validationDate" &&
          data.status !== 1 &&
          data.status !== 2 &&
          data.status !== 3 && (
            <DueDateSpan color="#474747" fontStyle="normal">
              {data.estimatedValidationDate
                ? getDateFormat(data.estimatedValidationDate, "YYYY-MM-DD")
                : "-"}
            </DueDateSpan>
          )}

        {column === "dunningInfoData" && (
          <>
            <DueDateSpan color={colorClass} fontStyle="normal">
              {data.dunningDate
                ? getDateFormat(data.dunningDate, "YYYY-MM-DD")
                : "-"}
              {data?.followupComment && (
                <span id={tooltipId}>
                  <Image
                    src={commentIcon}
                    alt="comment"
                    className="quote-listing__action-image-icon"
                  />
                </span>
              )}
            </DueDateSpan>
            {data?.followupComment && (
              <Tooltip
                anchorSelect={tooltipAnchor}
                style={DivToolTip}
                content={data?.followupComment}
              />
            )}
          </>
        )}
      </DivBackgroundOpacity>
    </>
  );
};

QuoteGeneralInfo.defaultProps = {};

QuoteGeneralInfo.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation()(QuoteGeneralInfo);
